import React from 'react';

import { AlertCard } from '../../../../../components/AlertCard';

interface ErrorDisplayProps {
  error: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  return <AlertCard type="error" title="Update Failed" message={error} />;
};
